(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/overview-attributes.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/overview-attributes.js');

'use strict';

const {
  getSexType
} = svs.racing.common.strings;
const Attributes = _ref => {
  let {
    age,
    sex,
    record
  } = _ref;
  const attributes = [{
    label: 'Ålder',
    value: age ? "".concat(age, " \xE5r") : '-'
  }, {
    label: 'Kön',
    value: sex ? getSexType(sex) : '-'
  }, {
    label: 'Rekord',
    value: record ? record : '-'
  }];
  return React.createElement(React.Fragment, null, attributes.map(attribute => React.createElement("div", {
    className: "overview-attributes-item",
    key: attribute.label
  }, React.createElement("div", {
    className: "overview-attributes-item-text"
  }, React.createElement("span", {
    className: "block fc-racing-900"
  }, attribute.label), React.createElement("span", {
    className: "f-bold"
  }, attribute.value)))));
};
svs.racing_game.components.statistics.Attributes = Attributes;

 })(window);